// number as svg paths to use in custom pin
const numbersPaths = [
  `<path d="M39.26 9.02V8.145H39.725C40.96 8.145 41.3 7.73 41.3 6.895V6.8H42.42V14H41.24V9.02H39.26Z" fill="#292929"/>`, //number 1
  `<path d="M38.54 8.815C38.58 7.44 39.605 6.675 41.155 6.675C42.705 6.675 43.64 7.44 43.64 8.73C43.64 10 42.79 10.71 41.735 11.615L40.15 13.01H43.695V14H38.455V13.185L41.195 10.695C41.975 9.98 42.45 9.505 42.45 8.785C42.45 8.095 41.985 7.67 41.14 7.67C40.285 7.67 39.7 8.085 39.68 8.965H38.54V8.815Z" fill="#292929"/>`, // number 2
  `<path d="M38.635 6.8H43.765V7.655L41.39 9.615H41.495C42.775 9.615 43.78 10.315 43.78 11.735C43.775 13.205 42.8 14.12 41.11 14.12C39.42 14.12 38.395 13.205 38.375 11.96V11.81H39.495C39.52 12.58 40.115 13.13 41.095 13.13C42.085 13.13 42.615 12.58 42.615 11.745C42.62 10.915 42.025 10.45 40.97 10.45H40.01V9.595L42.185 7.79H38.635V6.8Z" fill="#292929"/>`, // number 3
  `<path d="M38.26 12.155V11.305L41.62 6.8H43.17V11.21H44.255V12.155H43.17V14H41.98V12.155H38.26ZM39.45 11.21H41.98V7.945H41.9L39.45 11.21Z" fill="#292929"/>`, //number 4
  `<path d="M38.975 6.8H43.435V7.79H40L39.805 9.7H39.885C40.11 9.44 40.57 9.12 41.415 9.12C42.76 9.12 43.765 10.01 43.765 11.54C43.765 13.085 42.8 14.12 41.06 14.12C39.32 14.12 38.445 13.1 38.415 12.08V11.93H39.54C39.57 12.545 40.08 13.13 41.05 13.13C42.03 13.13 42.6 12.505 42.6 11.58C42.6 10.69 42.02 10.095 41.1 10.095C40.345 10.095 39.86 10.515 39.665 11.04H38.57L38.975 6.8Z" fill="#292929"/>`, //number 5
  `<path d="M43.995 11.61C43.995 13.06 43.005 14.115 41.315 14.115C39.585 14.115 38.43 13.095 38.43 10.595C38.43 7.79 39.615 6.685 41.375 6.685C43.07 6.685 43.75 7.685 43.825 8.58V8.73H42.74C42.67 8.185 42.31 7.655 41.395 7.655C40.335 7.655 39.635 8.395 39.6 10.14H39.675C39.93 9.69 40.5 9.225 41.56 9.225C43.005 9.225 43.995 10.15 43.995 11.61ZM39.77 11.65C39.77 12.555 40.385 13.13 41.315 13.13C42.235 13.13 42.845 12.555 42.845 11.65C42.845 10.745 42.235 10.17 41.315 10.17C40.385 10.17 39.77 10.745 39.77 11.65Z" fill="#292929"/>`, //number 6
  `<path d="M39.35 6.8H44.68V7.695L41.57 14H40.31V13.85L43.35 7.79H39.35V6.8Z" fill="#292929"/>`, //number 7
  `<path d="M38.585 8.595C38.585 7.435 39.56 6.67 41.205 6.67C42.845 6.67 43.82 7.435 43.82 8.595C43.82 9.67 43.105 10.095 42.69 10.21V10.29C43.13 10.42 44.02 10.845 44.02 12.06C44.02 13.315 42.96 14.13 41.205 14.13C39.445 14.13 38.39 13.315 38.39 12.06C38.39 10.845 39.265 10.42 39.72 10.29V10.21C39.3 10.09 38.585 9.67 38.585 8.595ZM39.565 11.985C39.565 12.72 40.19 13.175 41.205 13.175C42.215 13.175 42.84 12.72 42.84 11.985C42.84 11.25 42.215 10.795 41.205 10.795C40.19 10.795 39.565 11.25 39.565 11.985ZM39.725 8.735C39.725 9.42 40.275 9.84 41.205 9.84C42.13 9.84 42.685 9.42 42.685 8.735C42.685 8.045 42.13 7.625 41.205 7.625C40.275 7.625 39.725 8.045 39.725 8.735Z" fill="#292929"/>`, //number 8
  `<path d="M38.36 9.19C38.36 7.74 39.35 6.685 41.04 6.685C42.77 6.685 43.925 7.705 43.925 10.205C43.925 13.01 42.74 14.115 40.98 14.115C39.285 14.115 38.605 13.115 38.53 12.22V12.07H39.615C39.685 12.615 40.045 13.145 40.96 13.145C42.02 13.145 42.72 12.405 42.755 10.66H42.68C42.425 11.11 41.855 11.575 40.795 11.575C39.35 11.575 38.36 10.65 38.36 9.19ZM39.51 9.15C39.51 10.055 40.12 10.63 41.04 10.63C41.97 10.63 42.585 10.055 42.585 9.15C42.585 8.245 41.97 7.67 41.04 7.67C40.12 7.67 39.51 8.245 39.51 9.15Z" fill="#292929"/>`, //number 9
  `<path d="M36.208 11.016V10.316H36.58C37.568 10.316 37.84 9.984 37.84 9.316V9.24H38.736V15H37.792V11.016H36.208ZM39.6801 12.12C39.6801 10.188 40.5161 9.144 42.0361 9.144C43.5601 9.144 44.3921 10.188 44.3921 12.12C44.3921 14.052 43.5601 15.096 42.0361 15.096C40.5161 15.096 39.6801 14.052 39.6801 12.12ZM40.6481 12.12C40.6481 13.568 41.1361 14.312 42.0361 14.312C42.9361 14.312 43.4241 13.568 43.4241 12.12C43.4241 10.672 42.9361 9.972 42.0361 9.972C41.1361 9.972 40.6481 10.672 40.6481 12.12ZM45.2062 11.772H46.7702V10.136H47.5302V11.772H49.0942V12.456H47.5302V14.092H46.7702V12.456H45.2062V11.772Z" fill="#292929"/>`, // number 10+
];

export const IconMapPinMultiple = (
  number: number,
  animated = false,
  isUnavailable = false,
) => {
  if (number > 10) number = 10;

  const animationStyle = animated
    ? `
    <style>
      .pin-pulse {
        animation: pinPulse 1.5s ease-in-out infinite;
      }
      @keyframes pinPulse {
        0% { transform: scale(1); opacity: 1; }
        50% { transform: scale(1.2); opacity: 0.8; }
        100% { transform: scale(1); opacity: 1; }
      }
    </style>
  `
    : "";

  const lightColor = isUnavailable ? "#D1D5DB" : "#FDF4A0";
  const darkColor = isUnavailable ? "#9CA3AF" : "#F9E10B";
  const circleColor = isUnavailable ? "#9CA3AF" : "#F9E10B";
  const strokeColor = isUnavailable ? "#D1D5DB" : "#FDF4A0";

  return `<svg
  width="52"
  height="57"
  viewBox="0 0 52 57"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  class="${animated ? "pin-pulse" : ""}"
>
  ${animationStyle}
  <g filter="url(#filter0_d_2102_34768)">
    <path
      d="M4 18C4 13.5817 7.58172 10 12 10H38C42.4183 10 46 13.5817 46 18V41C46 45.4183 42.4183 49 38 49H4V18Z"
      fill="${lightColor}"
    />
    <path
      d="M8 22C8 17.5817 11.5817 14 16 14H34C38.4183 14 42 17.5817 42 22V37C42 41.4183 38.4183 45 34 45H16C11.5817 45 8 41.4183 8 37V22Z"
      fill="${darkColor}"
    />
    <path
      d="M20.8053 35.4122V36.4012H19.2724L16 22.5941V22.0002H17.0965C17.1205 22.0002 17.1197 22.0168 17.1259 22.0406L20.0911 34.7407C20.1267 34.8991 20.1685 34.9989 20.2459 35.0511C20.3059 35.0889 20.376 35.1066 20.4463 35.1018C20.4605 35.1026 20.4747 35.1026 20.4889 35.1018C20.5298 35.0998 20.5708 35.1063 20.6092 35.121C20.6477 35.1357 20.6828 35.1582 20.7124 35.1873C20.742 35.2164 20.7655 35.2513 20.7815 35.29C20.7975 35.3286 20.8056 35.3702 20.8053 35.4122Z"
      fill="#3C2110"
    />
    <path
      d="M31.0312 31.1778C31.0312 34.597 28.8042 36.4039 26.0015 36.4039C23.1987 36.4039 20.9717 34.5993 20.9717 31.1778C20.9717 27.7563 23.1995 25.9518 26.0015 25.9518C28.8034 25.9518 31.0312 27.7587 31.0312 31.1778ZM26.0015 34.882C27.9507 34.882 29.3427 33.5525 29.3427 31.1778C29.3427 28.8031 27.9499 27.4737 26.0015 27.4737C24.053 27.4737 22.6601 28.8031 22.6601 31.1778C22.6601 33.5525 24.0515 34.882 26.0007 34.882H26.0015Z"
      fill="#3C2110"
    />
    <path
      d="M31.1948 35.412V36.401H32.7278L36.0002 22.5939V22H34.9091C34.8851 22 34.8851 22.0166 34.8789 22.0404L31.9106 34.7405C31.875 34.8989 31.8332 34.9987 31.7558 35.0509C31.6958 35.0887 31.6257 35.1064 31.5554 35.1016C31.5413 35.1024 31.527 35.1024 31.5129 35.1016C31.4717 35.0994 31.4306 35.1057 31.392 35.1203C31.3534 35.1349 31.3181 35.1575 31.2883 35.1865C31.2585 35.2156 31.2349 35.2506 31.2188 35.2894C31.2027 35.3281 31.1946 35.3699 31.1948 35.412Z"
      fill="#3C2110"
    />
  </g>
  <circle
    cx="41.5"
    cy="10.5"
    r="8.5"
    fill="${circleColor}"
    stroke="${strokeColor}"
    stroke-width="4"
  />
  ${numbersPaths[number - 1]}
  <defs>
    <filter
      id="filter0_d_2102_34768"
      x="0"
      y="10"
      width="50"
      height="47"
      filterUnits="userSpaceOnUse"
      color-interpolation-filters="sRGB"
    >
      <feFlood flood-opacity="0" result="BackgroundImageFix" />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset dy="4" />
      <feGaussianBlur stdDeviation="2" />
      <feComposite in2="hardAlpha" operator="out" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
      />
      <feBlend
        mode="normal"
        in2="BackgroundImageFix"
        result="effect1_dropShadow_2102_34768"
      />
      <feBlend
        mode="normal"
        in="SourceGraphic"
        in2="effect1_dropShadow_2102_34768"
        result="shape"
      />
    </filter>
  </defs>
</svg>`;
};
